var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconTimeExerciseTime2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.361 17.846a.5.5 0 0 1-.707.015l-.015-.015-4.755-4.958A3.027 3.027 0 0 1 6.317 9.4h0a3.025 3.025 0 0 1 4.846-.786l.837.83.835-.835a3.024 3.024 0 0 1 4.845.786h0a3.027 3.027 0 0 1-.566 3.493Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.531 12.461h2.685l1.385-1.846 1.846 3.693 1.846-1.847h3.173M12 23.25v-2.368M12 .75v2.368M23.25 12h-2.368M.75 12h2.368m16.836-7.954L18.28 5.72M4.044 19.956l1.676-1.675M4.044 4.046 5.72 5.72m14.234 14.236-1.674-1.675"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 11.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTimeExerciseTime2);
export default __webpack_public_path__ + "static/media/streamline-icon-time-exercise-time-2.49ed0a3e.svg";
export { ForwardRef as ReactComponent };